import axios from 'axios'
import {handleError} from '../handleError'
import {LError} from '../../object'
const state = {}
const mutations = {}
const getters = {}
const actions = {
  /* 获取待审核的车辆列表 */
  async getVehicleList ({dispatch}, {searchParam, pagination}) {
    let url = '/passApi/check/list?page=' + (pagination.page - 1) + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = axios.post(url, searchParam)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 获取个人车辆列表 */
  async getSelfVehicleList ({dispatch}, {pagination}) {
    let url = '/passApi/check/list/self?page=' + (pagination.page - 1) + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 审核车辆 */
  async reviewVehicle ({dispathc}, {result, id, comment}) {
    let url = '/pipe/pass/checkAndBindToPassGroup/' + id + '/' + result
    try {
      let res = null
      res = await axios.post(url, {'comment': comment})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 获取到全局配置 */
  async getCommonConfig ({dispatch}) {
    let url = '/passApi/global/config?token=registration_global_config'
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 提交全局配置 */
  async submitCommonConfig ({dispatch}, param) {
    let url = '/passApi/global/check/config'
    try {
      let res = null
      res = await axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 获取配置列表 */
  async getConfigList ({dispatch}, {searchParam, pagination}) {
    let url = '/passApi/check/config/list?page=' + (pagination.page - 1) + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = await axios.post(url, searchParam)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getRegisterConfigList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passApi/check/config/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  /* 添加个人配置 */
  async putConfig ({dispatch}, param) {
    let url = '/passApi/check/config'
    try {
      let res = null
      res = await axios.put(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 删除配置 */
  async deleteConfig ({dispatch}, ids) {
    let url = '/passApi/check/config'
    try {
      let res = null
      res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async addExtraConfig ({dispatch}, {ids, type, id,userType,referIdSlot}) {
    let url
    if(userType==='person'&&type==='admin'){
      url = '/passObjectApi/check/group/' + type + '?groupId=' + id
    }
    else{
      url = '/passApi/check/group/' + type + '?groupId=' + id
    }
    try {
      let res = null
      res = await axios.put(url, {
        referIdSlot:referIdSlot,
        configs: ids
      })
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getExtraConfig ({dispatch}, {type, id,userType}) {
    let url;
    if(userType==='person'&&type==='admin'){
      url = '/passObjectApi/check/group/' + type + '/list?groupId=' + id
    }
    else{
      url = '/passApi/check/group/' + type + '/list?groupId=' + id
    }
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 车辆绑定 */
  async vehicleBind ({dispatch}, {param, owner}) {
    let url = ''
    if (owner === undefined) {
      url = '/passApi/check/vehicle'
    }
    else {
      url = '/passApi/check/vehicle?owner=' + owner
    }
    try {
      let res = null
      res = await axios.post(url, param)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 删除已审核车辆 */
  async deleteVehicles ({dispatch}, {ids,status}) {
    let url = '/passApi/check/vehicle?force='+status
    try {
      let res = null
      res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  }
}
export default{
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
